<template>
  <li>
    <div class="context-menu-toggle" :data-testid="getDataTestId(props.title)">
      <FormKit type="toggle" v-model="model" :label="props.title" @change="(event: Event, value: boolean) => $emit('update:modelValue', value)" :data-testid="getDataTestId(`toggle-${props.title}`)" />
    </div>
  </li>
</template>
<script setup lang="ts">
import { getDataTestId } from './ItemsHelper';

export interface MenuToggleProps {
  title: string;
  onChange?: string;
  subtitle?: string;
  disabled?: boolean;
  isToggle?: boolean;
}

const props = defineProps<MenuToggleProps>();
const model = defineModel({ default: false });
</script>

<style scoped>
.formkit-outer {
  @apply mb-0 hover:bg-slate-100 dark:hover:bg-zinc-700 active:bg-slate-300 dark:text-zinc-300 dark:hover:text-zinc-300 focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none;
}
</style>

<style>
.context-menu-toggle .formkit-outer .formkit-wrapper {
  @apply mb-0 gap-2 px-2 py-[0.625rem] relative z-20;
}

.context-menu-toggle .formkit-outer .formkit-wrapper > div {
  @apply w-6 h-6 mr-0 flex items-center;
}

.context-menu-toggle .formkit-outer .formkit-wrapper label {
  @apply mb-0 mr-0;
}

.context-menu-toggle .formkit-outer .formkit-wrapper label::before {
  @apply content-[''] absolute inset-0 -z-10 hover:bg-slate-100 dark:hover:bg-zinc-700;
}

.context-menu-toggle .formkit-track {
  @apply !min-w-6 p-[3px];
}

.context-menu-toggle .formkit-thumb {
  @apply w-2 h-2;
}
</style>
